(() => {
  const CARD_CLASS = 'ra-delivery-estimate';

  function findDescriptionBlock(wrapper) {
    const blocks = wrapper.querySelectorAll('.main-product__block');

    return Array.from(blocks).find((block) => {
      const text = (block.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      return text.includes('descrizione prodotto');
    });
  }

  function addDeliveryEstimate(root = document) {
    const wrappers = root.querySelectorAll
      ? root.querySelectorAll('.m-main-product .m-product-info--wrapper')
      : [];

    wrappers.forEach((wrapper) => {
      const descriptionBlock = findDescriptionBlock(wrapper);
      if (!descriptionBlock) return;

      let card = wrapper.querySelector(`.${CARD_CLASS}`);

      if (!card) {
        card = document.createElement('div');
        card.className = CARD_CLASS;
        card.setAttribute('role', 'note');
        card.setAttribute('aria-label', 'Consegna stimata');
        card.innerHTML = `
          <span class="ra-delivery-estimate__icon" aria-hidden="true"></span>
          <div class="ra-delivery-estimate__content">
            <div class="ra-delivery-estimate__title">Consegna stimata</div>
            <div class="ra-delivery-estimate__primary">La maggior parte degli ordini arriva entro <strong>24–48 ore</strong></div>
            <div class="ra-delivery-estimate__secondary">Nei periodi di maggiore richiesta potrebbero essere necessarie fino a <strong>72 ore</strong>.</div>
          </div>
        `;
      }

      if (descriptionBlock.nextElementSibling !== card) {
        descriptionBlock.insertAdjacentElement('afterend', card);
      }
    });
  }

  function init() {
    addDeliveryEstimate();

    const observer = new MutationObserver(() => addDeliveryEstimate());
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => addDeliveryEstimate(event.target));
})();